"use strict";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiberOnboardingService = void 0;
var FiberOnboardingService;
(function (FiberOnboardingService) {
  /**
   * @title YOL Service
   * @version 1.3.4
   * @license MIT
   * @baseUrl /fiber-onboarding
   * @contact YOL Digital <digital-yol@sunrise.net>
   *
   * yol-fiber-onboarding-service [ 📜 View Changelog](/fiber-onboarding/internal/release-note)
   */
  class Api {
    constructor(url, http) {
      this.public = {
        /**
        * No description
        *
        * @tags public
        * @name DoFiberOnboarding
        * @request GET:/fiber-onboarding/onboarding/fiber/{subscriptionId}
        * @secure bearerAuth
        * @response `200` `OnBoardingResponse` Ok
        * @response `404` `{
        error: "ERR_ORDER_NOT_FOUND" | "ERR_SUBSCRIPTION_NOT_FOUND" | "ERR_NO_INSTALLATION_ORDER_FOUND",
             }`
        * @response `500` `{
        error: "ERR_FROM_API" | "ERR_SYSTEM_ERROR" | "ERR_GENERIC_COM_ERROR",
             }`
        */
        doFiberOnboarding: (subscriptionId, params = {}) => this.http.request("GET", `${this.url}/fiber-onboarding/onboarding/fiber/${subscriptionId}`, {
          ...params
        })
      };
      this.http = http;
      this.url = url;
    }
  }
  FiberOnboardingService.Api = Api;
})(FiberOnboardingService || (exports.FiberOnboardingService = FiberOnboardingService = {}));